import { render, staticRenderFns } from "./cognitoAuth.vue?vue&type=template&id=7e6d4998&"
import script from "./cognitoAuth.vue?vue&type=script&lang=ts&"
export * from "./cognitoAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports